import { createContext, useContext, useState, useEffect } from 'react';
import { getStorageItem, setStorageItem } from '@/utils/storage';

interface SidebarContextType {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
}

const SidebarContext = createContext<SidebarContextType | null>(null);

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return getStorageItem('sidebar-collapsed', true);
  });

  // Persist state to localStorage
  useEffect(() => {
    setStorageItem('sidebar-collapsed', isCollapsed);
  }, [isCollapsed]);

  const toggleCollapsed = () => setIsCollapsed(prev => !prev);

  return (
    <SidebarContext.Provider value={{ isCollapsed, toggleCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}